module.exports = __webpack_public_path__ + "img/DerAufprall16.1e516a2e.jpg";